(function () {
    'use strict';

    angular.module('swif.interventions')
    .directive('listGroupItemRequest', listGroupItemRequest)
    .directive('panelInterventionRequest', panelInterventionRequest)
    .directive('interRequester', interRequester)
    .directive('tableInterventionRequests', tableInterventionRequests);

    /**
    * @ngdoc directive
    * @name swif.openstc:listGroupItemRequest
    * @module swif.openstc
    * @restrict A
    **/
    function listGroupItemRequest () {
        return {
            restrict: 'A',
            replace: true,
            scope: {
                listGroupItemRequest: '='
            },
            templateUrl: 'partials/openstc/list-group-item-request.html'
        };
    }

    /**
    * @ngdoc directive
    * @name swif.openstc:panelInterventionRequest
    * @module swif.openstc
    * @restrict E
    **/
    function panelInterventionRequest (swif) {
        'ngInject';

        console.log("panelInterventionRequest");
        var directive = swif.panel.create_directive('intervention_request', undefined, linked);
        directive.templateUrl = 'partials/openstc/panel-request.html';

        return directive;

        function linked(scope){
            var user = swif.user.getAuthenticatedUserData();
            scope.fullView = _.contains(user.access_rights, 'openstc_full_view');
        }
    }

    /**
    * @ngdoc directive
    * @name swif.openstc:interRequester
    * @module swif.openstc
    * @restrict E
    **/
    function interRequester (swif) {
        'ngInject';
        var directive = swif.panel.create_directive('intervention_request', undefined, linked);
        directive.scope.print = '=?';
        directive.templateUrl = 'partials/openstc/requester.html';
        return directive;

        function linked(scope) {
            var user = swif.user.getAuthenticatedUserData();
            scope.fullView = _.contains(user.access_rights, 'openstc_full_view');
            scope.$watch('item', function (newV) {
                if (newV) {
                    if (newV.partner_address) {
                        var filter = {};
                        filter.fields = ['email', 'phone', 'mobile'];
                        swif.data.get('partner_address', newV.partner_address[0], filter)
                        .then(function (data) {
                            scope.partner_address = data;
                        });
                    }
                }
            });
        }
    }

    /**
    * @ngdoc directive
    * @name swif.openstc:tableInterventionRequests
    * @module swif.openstc
    * @restrict A
    **/
    function tableInterventionRequests () {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: 'partials/openstc/requests_table_directive.html'
        };
    }

})();
